import React from 'react';
import { Alert } from 'antd';
import { FaExclamationTriangle } from 'react-icons/fa';

export const CreditWarningBanner: React.FC = () => {
  return (
    <Alert
      message={
        <div className="flex items-center gap-2">
          <FaExclamationTriangle className="text-yellow-600" />
          <div>
            <strong>Critical Separation:</strong> This dashboard is only accessible to Credit Control
            team. Sales team cannot access credit approval functions. Orders flow through:
            <strong> Sales → Credit Control → Processing</strong>
          </div>
        </div>
      }
      type="warning"
      showIcon={false}
      className="mb-6"
    />
  );
};

export default CreditWarningBanner;
